export default "__VITE_ASSET__b9d1883a__"